/**
 * Business logic validation helpers for show details
 */

import type { Show } from 'api-client/models';
import { isDateInFuture } from '@/utils/dateUtils';

/**
 * Determines if operational data (timing, ticketing, financial) should be shown.
 *
 * Hidden while a show is still tentative, so operational details cannot be
 * entered during the hold/challenge process — a show that is not yet booked has
 * no attendance or revenue to record.
 *
 * Must include `completed` and `settled`, not just `confirmed`: the financials of
 * a show you have already played and settled are precisely the numbers you go
 * back to look at.
 */
export const shouldShowOperationalData = (show: Show): boolean => {
  return ['confirmed', 'completed', 'settled'].includes(show.status ?? '');
};

/**
 * Check if a show date is in the future
 * Used to determine if certain fields should be editable
 */
export const isShowInFuture = (show: Show, _timezone?: string): boolean => {
  if (!show.showDate) return true;

  return isDateInFuture(show.showDate);
};
